import EnumSigningLevel from "./gen/qsign/types/EnumSigningLevel";
const labels = {
    [EnumSigningLevel.QUALIFIED]: "Kvalifikovaný",
    [EnumSigningLevel.GUARANTEED]: "Zaručený",
    [EnumSigningLevel.NONE]: "Žádný",
};

export function getCaption(source) {
    const caption = labels[source];
    return caption ? caption : "[" + source + "]";
}
